import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { nextCarouselKey, previousCarouselKey } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import SaveButton from '@/components/buttons/SaveButton';
import { updateActiveLookup } from '../../dictionaries/actions';
import { canEditDataset } from '../../helper';

const DictionaryLookupActions = ({
  onClose,
  onSave,
  showEditor,
  count,
  changeLookup,
  lookups,
  lookupName,
  canEdit,
  isDirty,
  saveStatus,
}) => (
  <Modal.Actions>
    <CloseButton onClick={onClose} />
    {count > 1 && (
    <>
      <BackButton onClick={() => changeLookup(previousCarouselKey(lookups, lookupName))} disabled={showEditor} />
      <ForwardButton onClick={() => changeLookup(nextCarouselKey(lookups, lookupName))} disabled={showEditor} />
    </>
    )}
    {canEdit && (
    <SaveButton
      onClick={onSave}
      minimumDataEntryMet={isDirty}
      inProgress={saveStatus === states.PENDING}
      messageId="actions.apply.changes"
    />
    )}
  </Modal.Actions>
);

const mapStateToProps = ({
  datasets: {
    lookups,
  },
  auth: {
    role,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const items = dictionary ? dictionary.lookups || {} : {};
  const count = Object.keys(items).length;
  const update = canEditDataset(lookups, role);

  return (
    {
      canEdit: update,
      count,
      isDirty: lookups.isDirty,
      lookupName: lookups.activeLookupName,
      lookups: items,
      saveStatus: lookups.saveStatus,
      showEditor: lookups.lookupBeingEdited.isEditing || (update && count === 0),
    }
  );
};

const mapDispatchToProps = {
  changeLookup: updateActiveLookup,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryLookupActions);
